/**
 * Preloads a list of images by creating Image objects
 * @param {Object} input - The input object containing images to preload
 * @param {string[]} input.images - Array of image URLs to preload
 */
export const preloadImages = (input) => {
  for (const image of input.images) {
    const img = new Image();
    img.src = image;
  }
};
